import * as qs from "query-string";
import _ from "lodash";
import { mapArrayToObject } from "./arrayUtils";

// Replaces the current query string value with the new provided value without triggering a page refresh.
export const setQueryStringWithoutPageReload = (qsValue) => {
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${qsValue}`;

    window.history.pushState({ path: newurl }, "", newurl);
};

// Updates the query string parameters only for the provided key, keeping the remaining parameters intact.
export const setQueryStringValue = (key, value, queryString = window.location.search) => {
    const values = qs.parse(queryString);
    const newValues = _.pickBy({ ...values, [key]: value }, (qsValue, qskey) => qsValue);

    const dateParam = newValues["filter[createdAt]"];

    if (dateParam) {
        newValues["filter[createdAt]"] = dateParam.replace(/ /g, "+");
    }

    const newQsValue = decodeURIComponent(qs.stringify(newValues));
    setQueryStringWithoutPageReload(newQsValue ? `?${newQsValue}` : "");
};

const getStringBetweenBrackets = (str) =>
    str.substring(str.indexOf("[") + 1, str.indexOf("]")) || str;

// Returns the query string value for the provided key.
export const getQueryStringValue = (key, queryString = window.location.search) => {
    const parsedParams = qs.parse(queryString, { arrayFormat: "comma" });

    // This handles: filter[client]=1,2&filter[driverId]=3 and retrns {client: ['1','2'], driverId: 3}
    let values = _.map(parsedParams, (item, itemKey) => {
        if (itemKey.includes(key) && itemKey !== key) {
            const filterKey = getStringBetweenBrackets(itemKey);
            return {
                [filterKey]:
                    filterKey === "createdAt" ? item.map((date) => date.replace(" ", "+")) : item,
            };
        }
    });

    values = _.without(values, undefined);

    if (!values.length) {
        return parsedParams[key];
    }

    values = mapArrayToObject(values);

    return values;
};
